import { Pipe, PipeTransform } from '@angular/core';
import { InstallationDimensionPluginService } from './dimension.service';
@Pipe({
    name: 'measuringunits',
    standalone: false
})
export class MeasuringUnitsPipe implements PipeTransform {
  public measuringUnits: any[];
  constructor(private service: InstallationDimensionPluginService) {
    this.measuringUnits = this.service.getMeasuringUnits();
  }
  transform(id: string): any {
    return this.service.getValue(parseInt(id), this.measuringUnits);
  }
}
